import { api } from '@cwd/lib/main';

export type Period = 'day' | 'week' | 'month';

export interface UnsubscribeReasonAccountStats {
    AccountId: string;
    AccountName: string;
    UnsubscribeCount: number;
    SpamCount: number;
    LatestUnsubscribe: string;
}

export async function getTopAccounts(period: Period, take = 10): Promise<UnsubscribeReasonAccountStats[]> {
    return api.get(`/UnsubscribeReasonStats/TopAccounts?period=${period}&take=${take}`);
}
